const getters = {
    tagList: state => state.tags.tagList,
    tagWel: state => state.tags.tagWel,
    tag: state => state.tags.tag,
    isCollapse: state => state.common.isCollapse,
    stateCase: state => state.common.stateCase,
    stateCase2: state => state.common.stateCase2,
    typeList: state => state.common.typeList,
    dictionary: state => state.common.dictionary,
    token: state => state.user.token,
    resourceToken: state => state.user.resourceToken,
    menu: state => state.user.menu,
    isCloseTip: state => state.user.isCloseTip,
    accessMenuId: state => state.user.accessMenuId,
    screen: state => state.common.screen,
    keyCollapse: (state, getters) => getters.screen > 1 ? getters.isCollapse : false,

}
export default getters
